import React, { useState } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import { makeStyles } from '@material-ui/core/styles';

//iconos
import { Assignment, Visibility } from '@material-ui/icons';

//tabla y card components
import Button from 'components/CustomButtons/Button.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

import { WithApp } from 'contexts/appContext';
import FilterCustom from 'components/Tvendo/Common/FilterCustom';
import { wsFindBy } from 'services/WService';
import { currency } from 'hooks/Pipe';
import { Link } from 'react-router-dom';

const useStyles = makeStyles({
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  }
});

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 110 },
  { Header: 'Almacén', accessor: 'WhsName' },
  { Header: 'Cód. Producto', accessor: 'ItemCode', width: 130 },
  { Header: 'Nombre producto', accessor: 'ItemName' },
  { Header: 'Cód. Proveedor', accessor: 'CardCode', width: 140 },
  { Header: 'Nombre proveedor', accessor: 'CardName' },
  { Header: '#Pedidos', accessor: 'orderCount', width: 100, align: 'center' },
  { Header: 'Uni. Comp.', accessor: 'commited_units', width: 110, align: 'center' },
  { Header: 'Monto', accessor: 'amount', width: 100, align: 'right' },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 }
];

export default WithApp(function ProductCommitted(props) {
  const classes = useStyles();

  const [saleProducts, setSaleProducts] = useState([]);
  const [dataLoading, setDataLoading] = useState(false);

  async function listSaleProducts(filter) {
    setDataLoading(true);
    let response = await wsFindBy('ordm/product-consolidate', filter);
    setDataLoading(false);
    if (response.success) setSaleProducts(response.data);
  }

  return (
    <Card>
      <CardHeader icon>
        <CardIcon color="primary">
          <Assignment style={{ color: 'white' }} />
        </CardIcon>
        <h4 className={classes.cardIconTitle}>Listado de productos comprometidos{dataLoading && <LoadingSpinner />}</h4>
      </CardHeader>
      <CardBody>
        <FilterCustom
          getFilter={listSaleProducts}
          dateRange
          diffRange={0}
          dateField="sale_date"
          warehouse="N"
          provider
        />

        <ReactTable
          excelName="Marcas"
          defaultWidth={1200}
          formatDate="DD-MM-YYYY"
          columns={columns}
          data={saleProducts.map((item, i) => {
            // TODO ? modificar permiso
            return {
              num: (
                <div className="actions-right">
                  {i + 1}
                  <AllowedGuard permission={ConstantPermissions.ORDM_ORDERS_SHOW}>
                    <Button justIcon round simple color={props.themeContext.buttonColor}>
                      <Link to={`${item.logi_product_id}/${item.logi_warehouse_id}`}>
                        <Visibility />
                      </Link>
                    </Button>
                  </AllowedGuard>
                </div>
              ),
              WhsName: `${item.WhsCode} - ${item.WhsName}`,
              ItemCode: item.ItemCode,
              ItemName: item.ItemName,
              CardCode: item.CardCode,
              CardName: item.CardName,
              orderCount: item.orderCount,
              commited_units: item.commited_units,
              amount: currency(item.amount),
              actions: ''
            };
          })}
        />
      </CardBody>
    </Card>
  );
});
